import EpisodesProvider from "@/containers/EpisodesProvider";
import MentionsListView from "@/views/MentionsView/List/index_v4";
import Typography from "@components/Typography";

import styles from "./LatestMentions.module.css";

const LatestMentions = () => {
  return (
    <EpisodesProvider>
      <div data-testid="dashboard--latest-mentions">
        <Typography
          variant="subtitle-1"
          className={styles["latest-mentions__header_title"]}
        >
          {L.DASHBOARD__LATEST_MENTIONS__TITLE}
        </Typography>

        <MentionsListView allowPagination={false} />
      </div>
    </EpisodesProvider>
  );
};

export default LatestMentions;
